export const SHOW_OPT_IN_KEY = 'show';
export const REQUIRED_KEY = 'required';
export const OPT_IN_KEY = 'consentSettings';
